import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { BranchAndDepartmentService } from 'src/app/services/branch-and-department.service';
import { AlertComponent } from '../../alert/alert.component';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  branchForm: FormGroup;
  dtOptions2: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  responseBranch: any;
  deleteBranchId: any;
  branchId: any;
  errorMessage: any;

  constructor(public branchAndDepartmentService: BranchAndDepartmentService, private loaderService:LoaderService, private alert: AlertComponent, private cdr: ChangeDetectorRef) {
    this.branchForm = new FormGroup({
      branchName: new FormControl('', [Validators.required]),
      branchId: new FormControl('', [Validators.required]),
      emailId: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      escalation_1: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      escalation_2: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    })
  }
  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }
  ngOnInit(): void {
    this.dtOptions2 = {
      pagingType: 'full_numbers',
      pageLength: 10,
      scrollX: true,
      scrollY: '420px',
      scrollCollapse: true,
      stateSave: true,
      dom: 'lBfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Committee List',
          title: 'Committee List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 5],
            format: {
              body: (data: any) => {
                if (
                  data.includes("+") || data.includes("@") ||
                  data.includes("=") || data.includes("|") ||
                  data.includes("!")
                ) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/)) {
                    return data;
                  } else {
                    return "'" + data + "'";
                  }
                } else {
                  return data;
                }
              }
            }
          }
        }
      ],
      columnDefs: [
        { orderable: false, targets: [3] },
        { className: "hide_col", targets: [5] }
      ],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]]
    };

    this.onGetBranchDetails();
  }

  onSave() {
    if (this.branchId) {
      this.onUpdate();
    } else {
      this.branchAndDepartmentService.addBranch(this.branchForm.value).subscribe(response => {

        $('#branchModel').modal('hide');
        this.alert.successWithOk1("Branch created successfully", () => {
          $('#branchModel').off('hidden.bs.modal');
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open');
          this.onGetBranchDetails();
        });
        this.branchForm.reset();

      }, err => {
        $('#branchModel').modal('hide');
      })
    }
  }

  onGetBranchDetails() {
    this.loaderService.enable();
    this.branchAndDepartmentService.getBranch().subscribe((response: any) => {
      this.responseBranch = response.data;

      // Re-render table (destroy existing first if needed)
      this.rerenderDataTable();
    });
  }


  rerenderDataTable(): void {
    if (this.dtElement?.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }




  onEdit(branch) {
    this.loaderService.disable();
    this.branchId = branch._id;
    this.branchForm.patchValue(branch);
    $('.modal-branchModel').remove();
    $('body').removeClass('modal-open');
    $('#branchModel').removeClass('show').hide();

    setTimeout(() => {
      $('#branchModel').modal('show');
    }, 100);
  }

  onUpdate() {
    this.branchId;
    this.branchAndDepartmentService.updateBranch(this.branchId, this.branchForm.value).subscribe(respData => {
      $('#branchModel').modal('toggle');
      this.branchId = null;
      this.branchForm.reset();
      this.alert.success("Branch updated successfully");
      this.onGetBranchDetails();
    }, error => {
      console.log("🚀 ~ file: department.component.ts ~ line 119 ~ DepartmentComponent ~ this.branchAndDepartmentService.update ~ error", error)
    })
  }

  onDeleteBranch(id) {
    this.deleteBranchId = id;
    $('#confirmation').modal('toggle');
  }

  deleteBranch() {
    this.branchAndDepartmentService.deleteBranch(this.deleteBranchId).subscribe(resp => {
      $('#confirmation').modal('toggle');
      this.onGetBranchDetails();
      this.alert.success("Branch deleted successfully");
    }, error => {
      console.log("🚀 ~ file: branch.component.ts ~ line 149 ~ BranchComponent ~ this.branchAndDepartmentService.deleteBranch ~ error", error)
      $('#confirmation').modal('toggle');
    })
  }

  onClose() {
    $('#confirmation').modal('toggle');
  }

  onChange(key, event) {
    this.branchAndDepartmentService.checkBranch({ [key]: event.target.value, _id: { $ne: this.branchId } }).subscribe((resData: any) => {
      if (resData.code == 0) {
        this.branchForm.controls[key].setErrors({ [key]: true });
        this.errorMessage = { [key]: `${event.target.value} is already exists` }
      } else {
        if (this.branchForm.controls[key].invalid) {
          this.branchForm.controls[key].setErrors({ [key]: false });
        }
        this.errorMessage = { [key]: false }
      }
    }, error => {
      console.log("🚀 ~ file: branch.component.ts ~ line 136 ~ BranchComponent ~ this.branchAndDepartmentService.checkBranch ~ error", error)
    })
  }

  restForm() {
    this.branchForm.reset();
  }

  removeId() {
    //$('#branchModel').modal('toggle');
    // Clean any leftover state just to be safe
    this.loaderService.disable();
    $('.modal-branchModel').remove();
    $('body').removeClass('modal-open');
    $('#branchModel').removeClass('show').hide();

    setTimeout(() => {
      $('#branchModel').modal('show');
    }, 100);
    this.branchId = null;
    console.log("🚀 ~ file: branch.component.ts ~ line 153 ~ BranchComponent ~ removeId ~ this.branchId", this.branchId)
  }
}
